import { useQuery } from "react-query";
import customAxios from "../utils/customAxios";

const axios = customAxios()

const fetchCodebookApi = () => {
    return axios.get(`/codebook`)
}

export const useCodebookApi = (prop?: any) => {
return useQuery(["fetchCodebookApi", prop], fetchCodebookApi, {
    staleTime: 10000,
    select,
    onError,
    refetchOnWindowFocus: false,
})
}


// api 응답 데이터 가공하는 부분
const select = (response: any) => {
    return response.data
  }
  
  const onError = (err: any) => {
    return err
  }
  